<template>
  <div class="oido-button"
    :class="{ [style]: Boolean(style), 'has-label': Boolean(label), 'has-icon': Boolean(icon), 'primary': Boolean(primary), [icon]: Boolean(icon) && !iconIsSVGCode, 'disabled': disabled }">
    <span class="loader" v-if="showSpinner"></span>
    
    <span class="icon" v-if="icon" v-html="svg"></span>
    <div class="label" v-if="label" v-text="label"></div>
    <span class="badge" v-if="badge" v-text="badge"></span>
  </div>
</template>


<script>

const icons = {
  'lock-closed': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M336 208v-95a80 80 0 00-160 0v95" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><rect x="96" y="208" width="320" height="272" rx="48" ry="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>`,
  'lock-open': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M336 112a80 80 0 00-160 0v96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><rect x="96" y="208" width="320" height="272" rx="48" ry="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>`,
  'visible': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 00-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 000-17.47C428.89 172.28 347.8 112 255.66 112z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><circle cx="256" cy="256" r="80" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>`,
  'hidden': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM255.66 384c-41.49 0-81.5-12.28-118.92-36.5-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 00.14-2.94L93.5 161.38a2 2 0 00-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0075.8-12.58 2 2 0 00.77-3.31l-21.58-21.58a4 4 0 00-3.83-1 204.8 204.8 0 01-51.16 6.47zM490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 00-74.89 12.83 2 2 0 00-.75 3.31l21.55 21.55a4 4 0 003.88 1 192.82 192.82 0 0150.21-6.69c40.69 0 80.58 12.43 118.55 37 34.71 22.4 65.74 53.88 89.76 91a.13.13 0 010 .16 310.72 310.72 0 01-64.12 72.73 2 2 0 00-.15 2.95l19.9 19.89a2 2 0 002.7.13 343.49 343.49 0 0068.64-78.48 32.2 32.2 0 00-.1-34.78z"/><path d="M256 160a95.88 95.88 0 00-21.37 2.4 2 2 0 00-1 3.38l112.59 112.56a2 2 0 003.38-1A96 96 0 00256 160zM165.78 233.66a2 2 0 00-3.38 1 96 96 0 00115 115 2 2 0 001-3.38z"/></svg>`,
  'add': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 112v288M400 256H112"/></svg>`,
  'edit': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48" stroke-linecap="round" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></path><path d="M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"></path></svg>`,
  'delete': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path stroke-linecap="round" stroke-linejoin="round" d="M368 368L144 144M368 144L144 368" class="ionicon-fill-none ionicon-stroke-width"></path></svg>`,
  'clipboard': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M336 64h32a48 48 0 0148 48v320a48 48 0 01-48 48H144a48 48 0 01-48-48V112a48 48 0 0148-48h32" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></path><rect x="176" y="32" width="160" height="64" rx="26.13" ry="26.13" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></rect></svg>`,
  'close': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path stroke-linecap="round" stroke-linejoin="round" d="M368 368L144 144M368 144L144 368" class="ionicon-fill-none ionicon-stroke-width"></path></svg>`,
  'open': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48M336 64h112v112M224 288L440 72" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>`,
  'help': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M256 80a176 176 0 10176 176A176 176 0 00256 80z" stroke-miterlimit="10" class="ionicon-fill-none ionicon-stroke-width"></path><path d="M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296" stroke-linecap="round" stroke-miterlimit="10" stroke-width="28" class="ionicon-fill-none"></path><circle cx="250" cy="348" r="20"></circle></svg>`,
  'help': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M256 80a176 176 0 10176 176A176 176 0 00256 80z" stroke-miterlimit="10" class="ionicon-fill-none ionicon-stroke-width"></path><path d="M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296" stroke-linecap="round" stroke-miterlimit="10" stroke-width="28" class="ionicon-fill-none"></path><circle cx="250" cy="348" r="20"></circle></svg>`,
  'qrcode-doc': `<svg width="100%" height="100%" viewBox="0 0 161 199" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g><rect x="0" y="0" width="160.952" height="198.189" style="fill-opacity:0;"/><path d="M109.335,6.036L154.916,51.964C159.523,56.637 160.952,61.037 160.952,67.629L160.952,136.973C160.952,152.03 153.279,159.788 138.289,159.788L122.214,159.788L122.214,151.388L137.865,151.388C147.54,151.388 152.552,146.291 152.552,136.787L152.552,65.116L110.44,65.116C102.532,65.116 98.619,61.585 98.619,53.294L98.619,8.4L61.868,8.4C52.15,8.4 47.138,13.76 47.138,23.044L47.138,38.211L38.738,38.211L38.738,22.815C38.738,7.758 46.573,0 61.444,0L94.339,0C100.262,0 104.856,1.514 109.335,6.036ZM106.411,52.402C106.411,55.949 107.828,57.324 111.333,57.324L149.817,57.324L106.411,13.614L106.411,52.402Z" style="fill-opacity:0.85;fill-rule:nonzero;"/><path d="M0,175.184C0,190.284 7.673,197.999 22.663,197.999L99.551,197.999C114.541,197.999 122.214,190.241 122.214,175.184L122.214,109.112C122.214,101.294 121.136,97.821 116.292,92.953L67.861,44.114C63.231,39.398 59.477,38.211 52.287,38.211L22.663,38.211C7.835,38.211 0,46.012 0,61.026L0,175.184ZM8.4,174.978L8.4,61.255C8.4,51.971 13.412,46.611 23.13,46.611L53.778,46.611L53.778,95.635C53.778,104.316 58.13,108.304 66.447,108.304L113.814,108.304L113.814,174.978C113.814,184.502 108.802,189.599 99.084,189.599L23.087,189.599C13.412,189.599 8.4,184.502 8.4,174.978ZM67.303,100.293C63.326,100.293 61.789,98.756 61.789,94.779L61.789,49.645L112.028,100.293L67.303,100.293Z" style="fill-opacity:0.85;fill-rule:nonzero;"/></g><g transform="matrix(0.769222,0,0,0.769222,1.88873,88.4205)"><rect x="0" y="0" width="151.339" height="151.661" style="fill-opacity:0;"/><path d="M39.401,115.554L68.181,115.554C70.24,115.554 71.713,114.081 71.713,112.022L71.713,83.14C71.713,81.14 70.24,79.549 68.181,79.549L39.401,79.549C37.402,79.549 35.81,81.14 35.81,83.14L35.81,112.022C35.81,114.081 37.402,115.554 39.401,115.554ZM42.95,108.371L42.95,86.731L64.573,86.731L64.573,108.371L42.95,108.371ZM49.273,101.989L58.31,101.989L58.31,92.994L49.273,92.994L49.273,101.989ZM39.401,72.333L68.181,72.333C70.24,72.333 71.713,70.86 71.713,68.801L71.713,39.962C71.713,37.962 70.24,36.328 68.181,36.328L39.401,36.328C37.402,36.328 35.81,37.962 35.81,39.962L35.81,68.801C35.81,70.86 37.402,72.333 39.401,72.333ZM42.95,65.193L42.95,43.51L64.573,43.51L64.573,65.193L42.95,65.193ZM49.273,58.828L58.31,58.828L58.31,49.833L49.273,49.833L49.273,58.828ZM82.563,72.333L111.343,72.333C113.402,72.333 114.875,70.86 114.875,68.801L114.875,39.962C114.875,37.962 113.402,36.328 111.343,36.328L82.563,36.328C80.563,36.328 78.929,37.962 78.929,39.962L78.929,68.801C78.929,70.86 80.563,72.333 82.563,72.333ZM86.111,65.193L86.111,43.51L107.735,43.51L107.735,65.193L86.111,65.193ZM92.434,58.828L101.429,58.828L101.429,49.833L92.434,49.833L92.434,58.828ZM79.95,114.473L88.988,114.473L88.988,105.376L79.95,105.376L79.95,114.473ZM104.816,114.473L113.853,114.473L113.853,105.376L104.816,105.376L104.816,114.473ZM92.375,101.989L101.369,101.989L101.369,92.994L92.375,92.994L92.375,101.989ZM79.95,89.548L88.988,89.548L88.988,80.511L79.95,80.511L79.95,89.548ZM104.816,89.548L113.853,89.548L113.853,80.511L104.816,80.511L104.816,89.548Z" style="fill-opacity:0.85;fill-rule:nonzero;"/></g><g transform="matrix(1,0,0,1,-5.71429,87.2418)"><rect x="0" y="0" width="151.339" height="151.661" style="fill-opacity:0;"/></g></svg>`,
  'qrcode': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><rect x="336" y="336" width="80" height="80" rx="8" ry="8"/><rect x="272" y="272" width="64" height="64" rx="8" ry="8"/><rect x="416" y="416" width="64" height="64" rx="8" ry="8"/><rect x="432" y="272" width="48" height="48" rx="8" ry="8"/><rect x="272" y="432" width="48" height="48" rx="8" ry="8"/><rect x="336" y="96" width="80" height="80" rx="8" ry="8"/><rect x="288" y="48" width="176" height="176" rx="16" ry="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><rect x="96" y="96" width="80" height="80" rx="8" ry="8"/><rect x="48" y="48" width="176" height="176" rx="16" ry="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><rect x="96" y="336" width="80" height="80" rx="8" ry="8"/><rect x="48" y="288" width="176" height="176" rx="16" ry="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>`,
  'download': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M176 272l80 80 80-80M256 48v288"/></svg>`,
  'arrow-forward': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>`,
  'checked-circle': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336 160 272"/></svg>`,
  'empty-circle': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><circle cx="256" cy="256" r="192" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>`,
  'checked': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M416 128L192 384l-96-96"/></svg>`
}

export default {
  props: ['label', 'style', "icon", "showSpinner", "primary", "disabled", "badge"],
  computed: {
    iconIsSVGCode(){
      return  this.icon && (''+this.icon).startsWith('<svg')
    },
    svg() {
      let svg = null
      if (icons[this.icon]) {
        svg = icons[this.icon]
      }
      if(this.iconIsSVGCode){
        svg = ''+this.icon
      }
      return svg
    }
  }
};
</script>


<style scoped>
.oido-button {
  font-size: 0.8rem;
  font-weight: 300;
  padding: 0rem 0;


  font-weight: 599;
  display: inline-block;
  color: var(--ion-color-medium);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.oido-button.primary {
  color: var(--ion-color-primary);

}


.oido-button.bordered {
  border:1px solid var(--ion-color-primary);  
  padding: 0.7rem 1rem;
  border-radius: 3rem;
}
.oido-button.solid {
  background-color: var(--ion-color-medium);
  color: white;
  padding: 0.7rem 1rem;
}

.oido-button.solid.primary {
  background-color: var(--ion-color-primary);
}
.oido-button.disabled{
  pointer-events: none;
  color: #bbb;
}
.oido-button.solid.disabled {
  background-color: #ddd;
  color: white;
}

.icon {
  width: 1.1em;
  height: 1.1em;
  margin-right: .3em;
  position:relative;
  top: 0.02rem;
}

.oido-button.qrcode .icon {
  width: 1.3em;
  height: 1.3em;
  padding: 0.1em;
}

.loader {
  width: 1em;
  height: 1em;
  margin: 0 0.5rem;
  border: 2px solid var(--ion-color-primary);
  opacity: 0.8;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1.3s linear infinite;
}
.oido-button.solid .loader{
  border: 2px solid rgba(255, 255, 255, 0.9);
  opacity: 1;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
<style>
.oido-button:not(.qrcode-doc) svg {
  stroke: var(--ion-color-medium);
  fill: transparent;
  stroke-width: 35px;
}
.oido-button svg {
  overflow: visible;
  width: 100%;
}
.oido-button.solid svg {
  stroke: white;
}

.oido-button.primary svg {
  stroke: var(--ion-color-primary);
}
.oido-button.disabled svg {
  stroke: #bbb;
}
.oido-button.disabled.solid svg {
  stroke: white;
}

.oido-button.hidden svg{
  stroke: transparent;
  fill: var(--ion-color-medium);
  stroke-width: 0px;
}

.oido-button.solid,
.oido-button.bordered{
  .icon {
    margin-right: 0.5rem;
  }
}

.badge{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.3rem;
  border-radius: 0.9rem;
  min-width: 0.9rem;
  line-height: 0.9rem;
  font-size: 0.6rem;  
  background-color: var(--ion-color-primary);
  color: white;
  font-weight:400;
  
}
</style>
